<template>
	<div id="all">
		<div id="map" ref="map"></div>
		<div id="data">
			<div class="info-container">
				<div class="datetime-row">
					<strong>{{datetime}}</strong>
				</div>
				<div class="coords-row">
					<div class="coord-item">
						<span class="coord-label">Lat:</span>
						<strong class="coord-value">{{ coords.lat ? coords.lat.toFixed(9) : '--' }}</strong>
					</div>
					<div class="coord-item">
						<span class="coord-label">Lng:</span>
						<strong class="coord-value">{{ coords.lng ? coords.lng.toFixed(9) : '--' }}</strong>
					</div>
				</div>
			</div>

			<b-button variant="primary" ref="btn-position" @click="currentPosition" class="gps-button">
				<md-icon icon="gps_fixed" />
			</b-button>
		</div>
		<b-overlay :show="overlayShow" no-wrap no-center :opacity="1">
			<template #overlay>
				<div class="permission-screen">
					<div class="permission-content">
						<!-- Estado: Permiso denegado -->
						<div v-if="geolocationStatus == 'denied'" class="permission-state">
							<div class="icon-wrapper denied">
								<md-icon icon="location_off" :style="{ fontSize: '64px' }" />
							</div>
							<h2 class="permission-title">{{$t('driver.noPermission')}}</h2>
							<p class="permission-description">
								Es necesario habilitar los permisos de ubicación para usar esta herramienta
							</p>
							<b-button
								href="https://www.loom.com/share/edee95e69fd04b65af71655b06f705bc"
								target="_blank"
								size="lg"
								variant="info"
								class="action-button">
								<md-icon icon="help_outline" class="button-icon" />
								{{$t('driver.howAndroid')}}
							</b-button>
						</div>

						<!-- Estado: Esperando permiso -->
						<div v-if="geolocationStatus == 'prompt'" class="permission-state">
							<div class="icon-wrapper prompt">
								<md-icon icon="location_searching" :style="{ fontSize: '64px' }" />
							</div>
							<h2 class="permission-title">{{$t('driver.acceptPermission')}}</h2>
							<p class="permission-description">
								Presiona el botón y acepta los permisos cuando el navegador lo solicite
							</p>
						</div>

						<!-- Estado: Buscando ubicación -->
						<div v-if="geolocationStatus == 'granted'" class="permission-state">
							<div class="icon-wrapper granted">
								<md-icon icon="my_location" :style="{ fontSize: '64px' }" />
							</div>
							<h2 class="permission-title">{{$t('driver.findLocation')}}</h2>
							<p class="permission-description">
								Obteniendo tu ubicación actual...
							</p>
							<div class="loading-spinner"></div>
						</div>

						<!-- Botón principal -->
						<div class="action-section">
							<b-button
								size="lg"
								variant="primary"
								ref="btn-position"
								@click="currentPosition"
								class="gps-action-button">
								<md-icon icon="gps_fixed" :style="{ fontSize: '28px' }" />
							</b-button>
							<p class="action-label">Obtener ubicación</p>
						</div>

						<!-- Error de localización -->
						<div v-if="localizationError" class="error-message">
							<md-icon icon="error_outline" class="error-icon" />
							<strong>{{localizationError}}</strong>
						</div>
					</div>
				</div>
			</template>
		</b-overlay>
	</div>
</template>

<script>
import BlueMark from "../../../assets/blue-mark.png";


export default {
	components: { },
	data() {
		return {
			overlayShow: true,
			map: null,
			infoWindow: null,
			datetime:'',
			marker:null,
			geolocationStatus:'',
			localizationError:'',
			coords: {
				lat: null,
				lng: null
			}
		};
	},
	methods: {
		checkPermission(){
			let $this = this;
			navigator.permissions.query({name:'geolocation'}).then(function(result) {
				// Will return ['granted', 'prompt', 'denied']
				$this.geolocationStatus = result.state

				// Si ya tiene permisos, obtener ubicación automáticamente
				if (result.state === 'granted') {
					$this.currentPosition()
				}

				// Escuchar cambios en el permiso
				result.onchange = function() {
					$this.geolocationStatus = this.state
					if (this.state === 'granted') {
						$this.currentPosition()
					}
				}
			});
		},
		currentPosition(){
			this.datetime = this.$moment().format('D MMM YYYY HH:mm')+' hrs'
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
				position => {
					const pos = {
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					};

					this.coords = {...pos}

					if (this.map && this.marker) {
						this.marker.setPosition(pos)
						this.map.setCenter(pos);
						this.overlayShow = false
					} else {
						// El mapa no se inicializó, intentar de nuevo
						this.initMap().then(() => {
							if (this.map && this.marker) {
								this.marker.setPosition(pos)
								this.map.setCenter(pos);
								this.overlayShow = false
							}
						}).catch(() => {
							// Error ya manejado en initMap
						})
					}
				},
				err => {
					this.localizationError = `Error: ${err.message} Code: ${err.code} `
					this.overlayShow = true
					// console.log(err)
					// this.handleLocationError(true);
				},
				{
					enableHighAccuracy:true,
				}
				);
			} else {
				// Browser doesn't support Geolocation
				this.handleLocationError(false);
			}
		},
		handleLocationError(browserHasGeolocation) {
			this.localizationError = browserHasGeolocation
				? "The Geolocation service failed."
				: "Your browser doesn't support geolocation.";
			this.overlayShow = true
		},
		initMap() {
			return new Promise((resolve, reject) => {
				let attempts = 0;
				const maxAttempts = 50; // 5 segundos máximo (50 * 100ms)

				const checkGoogle = () => {
					if (window.google && window.google.maps) {
						this.map = new window.google.maps.Map(this.$refs["map"], {
							center: { lat: -34.397, lng: 150.644 },
							zoom: 15,
							mapTypeControl: false,
							streetViewControl: false,
							zoomControl: false,
							fullscreenControl: false,
						});
						const image = {
							url: BlueMark,
						}
						this.marker = new window.google.maps.Marker({
							position: { lat: -34.397, lng: 150.644 },
							map: this.map,
							icon: image,
						})
						resolve();
					} else if (attempts < maxAttempts) {
						attempts++;
						setTimeout(checkGoogle, 100);
					} else {
						this.localizationError = 'Error: No se pudo cargar Google Maps';
						reject(new Error('Google Maps timeout'));
					}
				};
				checkGoogle();
			});
		}
	},
	async mounted() {
		this.initMap()
		this.checkPermission()
	},
};
</script>

<style>
	body,html{
		width: 100%;
		height: 100%;
		position: relative;
	}
	#data{
		padding: 12px 16px;
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		background-color: white;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
		box-shadow: 0 -2px 8px rgba(0,0,0,0.1);
	}

	.info-container {
		flex: 1;
		min-width: 0;
	}

	.datetime-row {
		margin-bottom: 6px;
		font-size: 16px;
		color: #333;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.coords-row {
		display: flex;
		gap: 16px;
		flex-wrap: wrap;
	}

	.coord-item {
		display: flex;
		align-items: baseline;
		gap: 4px;
		font-size: 13px;
	}

	.coord-label {
		color: #666;
		font-weight: 500;
		font-size: 14px;
	}

	.coord-value {
		color: #0066cc;
		font-size: 14px;
		font-family: 'Courier New', monospace;
	}

	.gps-button {
		flex-shrink: 0;
		width: 48px;
		height: 48px;
		padding: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
	}

	#map {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
	}

	/* Optimizaciones para móviles pequeños */
	@media (max-width: 380px) {
		#data {
			padding: 10px 12px;
			gap: 8px;
		}

		.datetime-row {
			font-size: 12px;
			margin-bottom: 4px;
		}

		.coord-item {
			font-size: 11px;
		}

		.coord-value {
			font-size: 11px;
		}

		.coords-row {
			gap: 12px;
		}

		.gps-button {
			width: 44px;
			height: 44px;
		}
	}

	/* Para pantallas muy pequeñas, apilar coordenadas verticalmente si es necesario */
	@media (max-width: 320px) {
		.coords-row {
			flex-direction: column;
			gap: 4px;
		}
	}

	/* Estilos para la pantalla de permisos */
	.permission-screen {
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		padding: 20px;
	}

	.permission-content {
		width: 100%;
		max-width: 400px;
		text-align: center;
	}

	.permission-state {
		background: white;
		border-radius: 16px;
		padding: 32px 24px;
		margin-bottom: 24px;
		box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
	}

	.icon-wrapper {
		width: 96px;
		height: 96px;
		margin: 0 auto 20px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
	}

	.icon-wrapper.denied {
		background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
	}

	.icon-wrapper.prompt {
		background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
		animation: pulse 2s ease-in-out infinite;
	}

	.icon-wrapper.granted {
		background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
		animation: pulse 2s ease-in-out infinite;
	}

	@keyframes pulse {
		0%, 100% {
			transform: scale(1);
			opacity: 1;
		}
		50% {
			transform: scale(1.05);
			opacity: 0.9;
		}
	}

	.permission-title {
		font-size: 22px;
		font-weight: 700;
		color: #2d3748;
		margin-bottom: 12px;
		line-height: 1.3;
	}

	.permission-description {
		font-size: 15px;
		color: #718096;
		margin-bottom: 0;
		line-height: 1.5;
	}

	.action-button {
		margin-top: 20px;
		border-radius: 12px;
		padding: 12px 24px;
		font-weight: 600;
		display: inline-flex;
		align-items: center;
		gap: 8px;
	}

	.button-icon {
		font-size: 20px !important;
	}

	.action-section {
		margin-bottom: 20px;
	}

	.gps-action-button {
		width: 80px;
		height: 80px;
		border-radius: 50%;
		padding: 0;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		border: none;
		box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
		transition: transform 0.2s, box-shadow 0.2s;
	}

	.gps-action-button:hover {
		transform: translateY(-2px);
		box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
	}

	.gps-action-button:active {
		transform: translateY(0);
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
	}

	.action-label {
		color: white;
		font-size: 14px;
		font-weight: 600;
		margin-top: 12px;
		margin-bottom: 0;
		text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}

	.error-message {
		background: #fff5f5;
		border: 1px solid #fc8181;
		border-radius: 12px;
		padding: 16px;
		color: #c53030;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		font-size: 13px;
		line-height: 1.4;
	}

	.error-icon {
		flex-shrink: 0;
		font-size: 20px !important;
	}

	.loading-spinner {
		width: 40px;
		height: 40px;
		margin: 20px auto 0;
		border: 4px solid #e2e8f0;
		border-top-color: #667eea;
		border-radius: 50%;
		animation: spin 1s linear infinite;
	}

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}

	/* Ajustes para móviles */
	@media (max-width: 480px) {
		.permission-screen {
			padding: 16px;
		}

		.permission-state {
			padding: 24px 20px;
		}

		.permission-title {
			font-size: 20px;
		}

		.permission-description {
			font-size: 14px;
		}

		.icon-wrapper {
			width: 80px;
			height: 80px;
		}

		.gps-action-button {
			width: 72px;
			height: 72px;
		}
	}

	@media (max-width: 360px) {
		.permission-title {
			font-size: 18px;
		}

		.permission-description {
			font-size: 13px;
		}

		.icon-wrapper {
			width: 72px;
			height: 72px;
		}
	}
</style>
